import FormField, { BaseFormFieldProps } from './FormField';
import React, { Component } from 'react';
import { Select } from '@blueprintjs/select';
import { Button } from '@blueprintjs/core';
import { TranslatedMessage } from '../translation';
import { TLCode } from '../../../common/enums';

interface SelectInputFormFieldProps<T, V> extends BaseFormFieldProps {
  itemValueGetter: (item: T) => V;
  valueItemGetter: (value: V) => T;
  placeholderSelection?: TLCode;
  allowEmpty?: boolean;
  identifier: string;
  elementLabel: string;
  labelSelectAnElement?: string;
  afterItemSelected?: (id: number | undefined) => void;
}

class SelectInputFormField<T, V> extends Component<SelectInputFormFieldProps<T, V>> {
  public static ofType<T, V>() {
    return SelectInputFormField as new (props: SelectInputFormFieldProps<T, V>) => SelectInputFormField<T, V>;
  }

  get TypedSelectInput() {
    return Select.ofType<T>();
  }

  handleClear = (changeFunction) => {
    changeFunction(undefined);
  };

  render() {
    const {
      items,
      itemPredicate,
      itemValueGetter,
      valueItemGetter,
      inputValueRenderer,
      itemRenderer,
      placeholderSelection,
      allowEmpty,
      identifier,
      elementLabel,
      labelSelectAnElement,
      afterItemSelected,
    } = this.props;

    let finalItems = items;

    if (allowEmpty) {
      const emptyObject = {};
      emptyObject[identifier] = null;
      emptyObject[elementLabel] = labelSelectAnElement ? labelSelectAnElement : 'Select an element';
      finalItems = [emptyObject, ...finalItems];
    }

    return (
      <FormField {...this.props}>
        {({ input: { onChange, ...rest } }) => {
          const TypedSelectInput = this.TypedSelectInput;
          return (
            <TypedSelectInput
              onItemSelect={(item) => {
                onChange(itemValueGetter(item));

                if (afterItemSelected !== undefined) afterItemSelected(item[identifier]);
              }}
              itemPredicate={itemPredicate}
              itemRenderer={itemRenderer}
              {...rest}
              popoverProps={{ minimal: true }}
              items={finalItems}
            >
              <Button
                rightIcon="caret-down"
                disabled={this.props.disabled}
                text={
                  rest.value ? (
                    inputValueRenderer(valueItemGetter(rest.value))
                  ) : (
                    <TranslatedMessage id={placeholderSelection ? placeholderSelection : TLCode.NONE} />
                  )
                }
              />
              {this.props.isClearable == true && (<Button minimal rightIcon="cross" onClick={() => this.handleClear(onChange)} disabled={this.props.disabled} />)}
            </TypedSelectInput>
          );
        }}
      </FormField>
    );
  }
}

export default SelectInputFormField;
